module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Paragraph-2ed7690badd069bc213e30d4ce37fbbc.svg";